import React from 'react';
import { InputFile } from './input-file/input-file';
import { InputNumber } from './input-number';
import { InputText } from './input-text';
export const Input = () => React.createElement(React.Fragment, null);
Input.Text = InputText;
Input.Number = InputNumber;
Input.File = InputFile;
//# sourceMappingURL=input.js.map